module.exports = __webpack_public_path__ + "static/media/cabin-filter-change.46e7db15.svg";